import {AutomationNode} from 'crqlar-react-common/dist/models/automation/automation';

import {stepName} from './nodeCategories';
import {getNodeOutputs} from './nodeOutputs';

export interface AvailableVariable {
    name: string;
    type: string;
    description?: string;
    nodeName?: string;
}

/** `{{"<step label>".<output>}}` — the API resolves it against the node label at run time. */
export const buildAvailableVariables = (upstreamNodes: AutomationNode[]): AvailableVariable[] =>
    upstreamNodes.flatMap(node => {
        const nodeName = stepName(node);

        return getNodeOutputs(node.type).map(output => ({
            name: output.name,
            type: output.type,
            description: output.description,
            nodeName
        }));
    });
